<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/allForm/addGrabAndGo')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr>
      <div class="p-15 pt-0">
        <form @submit.prevent="editProduct('validateAddProduct')" data-vv-scope="validateAddProduct">
          <div class="row mb-10">
            <div class="col-md-6">
              <div class="mb-10">
                <b-form-input class="border-bottom" v-model="editData.name" placeholder="Product Name" v-validate="'required'" name="product_name" type="text"></b-form-input>
                <span class="error">{{ errors.first('validateAddProduct.product_name') }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-10">
                <b-form-input class="border-bottom" v-model="editData.price" placeholder="Product Price" v-validate="'required'" name="product_price" type="text"></b-form-input>
                <span class="error">{{ errors.first('validateAddProduct.product_price') }}</span>
              </div>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'editProductGrandAndGo',
  data: function () {
    return {
      editData: {
        name: '',
        price: ''
      }
    }
  },
  methods: {
    // onEditorChange(event) {
    //   console.log('onEditorChange')
    // },
    editProduct (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          axios.put('crm/v1/grab_and_go_product/' + this.$route.query.id, this.editData).then(response => {
            // console.log('test', response)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            this.$router.push('/allForm/addGrabAndGo')
          }).catch(error => {
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/grab_and_go_product/' + this.$route.query.id).then(response => {
        this.editData = response.data.data
        // price bertipe DECIMAL (string "15000.00"), tampilkan sebagai angka
        this.editData.price = Number(this.editData.price)
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
</style>
